import React from 'react';
import { BoxProps } from '@components/Box';
import { SelectTypographyProps, SelectWrapper, StyledJoykitIcon, StyledSelect, StyledSelectOption } from '@components/Select/Select.styles';

export interface SelectProps<T> extends SelectTypographyProps, Omit<BoxProps, 'color'> {
  value: T | '';
  options: ReadonlyArray<T>;
  selectAllLabel?: string;
  labelFunction: (value: T) => string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select = <T extends string>({
  value,
  options,
  selectAllLabel,
  labelFunction,
  onChange,
  typography,
  ...restProps
}: SelectProps<T>) => {
  return (
    <SelectWrapper {...restProps}>
      <StyledJoykitIcon name="downChevron" color="mono1" size={16} />
      <StyledSelect value={value} onChange={onChange} typography={typography} aria-label="Select">
        <StyledSelectOption value="" typography={typography}>
          {selectAllLabel}
        </StyledSelectOption>
        {options.map((option) => (
          <StyledSelectOption key={option} value={option} typography={typography}>
            {labelFunction(option)}
          </StyledSelectOption>
        ))}
      </StyledSelect>
    </SelectWrapper>
  );
};

export { Select };
